// =============================================================
//  Shree Abhushan Jewellers — central site configuration
//  Edit values here to update the website content easily.
// =============================================================

const siteConfig = {
  brand: {
    name: "Shree Abhushan Jewellers",
    nameGu: "શ્રી આભુષણ જવેલર્સ",
    house: "Soni Ramchandra Nenshi (Adhoivala)",
    houseGu: "સોની રામચંદ્ર નેણસી (આઘોઈવાળા)",
    tagline: "Heritage Gold & Bridal Jewellery of Kutch",
    estd: "Crafted with trust since generations",
    logo: "/assets/logo.png",
    domain: "shreeabhushanjewellers.com",
  },

  // The marquee tagline shown beside the live gold rate
  marqueeTagline:
    "Welcome to Shree Abhushan Jewellers, Bhachau (Kutch) — Authentic Hallmark Gold • BIS 916 Jewellery • HM HUID Available • Bridal Sets • Daily Updated Rates",

  // Live rates API — served by the PHP/MySQL rate panel on the subdomain.
  // The shop owner logs in there and updates rates; the marquee reflects them.
  // (See the /rate-panel folder + its README for cPanel deployment.)
  ratesApi: "https://test.shreeabhushanjewellers.com/rates.php",

  // How often (seconds) the website re-checks the panel for new rates,
  // so updates appear without the visitor refreshing the page.
  ratesPollSeconds: 60,

  // Fallback rates shown if the API is unreachable (and before it loads).
  // The live values (all karats) come from the rate panel API above.
  rates: {
    gold24k: 73200, // per 10 grams (₹)
    gold22k: 67100, // per 10 grams (₹)
    gold20k: 61000, // per 10 grams (₹)
    gold18k: 54900, // per 10 grams (₹)
    gold14k: 42700, // per 10 grams (₹)
    gold9k: 27450, // per 10 grams (₹)
    silver: 92000, // per kilogram (₹)
    updatedOn: "27 June 2026",
  },

  contact: {
    phonePrimary: "+91 89801 56390",
    phonePrimaryName: "Hitarthbhai",
    whatsapp: "918980156390",
    email: "abhushanjewellers20@gmail.com",
    addressLine1: "Main Road, Ramwadi Vistar,",
    addressLine2: "Near Paresh Tea, Bhachau,",
    addressLine3: "Kutch (Kachchh), Gujarat — 370140",
    addressGu: "મેઈન રોડ, રામવાડી વિસ્તાર, પરેશ ચા ની બાજુમાં, ભચાઉ (કચ્છ)",
    hours: "Open Daily · 10:00 AM – 9:00 PM",
    mapEmbed:
      "https://maps.google.com/maps?q=Shree%20Abhushan%20Jewellers%20Bhachau%20Kutch&t=&z=15&ie=UTF8&iwloc=&output=embed",
    mapLink:
      "https://www.google.com/search?q=Shree+Abhushan+Jewellers+Bhachau",
    // Social media — the owner can replace these with the exact page/profile URLs.
    social: {
      facebook: "https://www.facebook.com/shreeabhushanjewellers",
      instagram: "https://www.instagram.com/shreeabhushanjewellers",
      googleReviews:
        "https://www.google.com/search?q=Shree+Abhushan+Jewellers+Bhachau#lrd=,1",
    },
  },

  // Jewellery categories (the client can add / rename these).
  // Icons are mapped by id in src/components/icons.js (react-icons).
  categories: [
    { id: "necklaces", name: "Necklaces & Sets" },
    { id: "bridal", name: "Bridal Collection" },
    { id: "earrings", name: "Earrings" },
    { id: "rings", name: "Rings" },
    { id: "bangles", name: "Bangles & Kada" },
    { id: "chains", name: "Chains & Mangalsutra" },
    { id: "anklets", name: "Payal & Anklets" },
    { id: "watches", name: "Gold Watches" },
  ],
};

export default siteConfig;
